import { DIRECTUS_TRANSLATIONS_PRODUCT_ID } from "assets/constants";
export default defineI18nLocale(async (locale) => {
  return await useFetch(`https://products.7span.in/items/tl_items`, {
    headers: {
      // Setting Authorization to null or else bearer token is sent which results into 401 error
      Authorization: null,
    },
    params: {
      limit: -1,
      fields: ["key", locale],
      filter: {
        _and: [
          {
            _and: [
              {
                product: {
                  id: {
                    _eq: DIRECTUS_TRANSLATIONS_PRODUCT_ID,
                  },
                },
              },
            ],
          },
          {
            status: {
              _neq: "archived",
            },
          },
        ],
      },
    },
  }).then(({ data }) => {
    /** OUPUT
     * For en locale
     * { login : 'login', ... }
     */
    return data.value.data.reduce((result, item) => {
      result[item.key] = item[locale];

      return result;
    }, {});
  });
});
